export default {
  title: "Completion of registration of a new user"
};
